import Vue from 'vue'
import Router from 'vue-router'
import Report from '@/views/Report/index'
import Reporttxt from '@/views/Reporttxt/index'
import History from '@/views/History/index'
import safetyCode from '@/views/safetyCode/index'
Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            name: 'Report',
            component: Report,
            props: true,
        },
        {
            path: '/Reporttxt',
            name: 'Reporttxt',
            component: Reporttxt,
            props: true,
        },
        {
            path: '/History',
            name: 'History',
            component: History,
            props: true,
        },
        {
            path: '/safetyCode',
            name: 'safetyCode',
            component: safetyCode,
            props: true,
        },
    ],
})